import React from "react";
import { Box, Container, Typography, Card, CardContent } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { motion } from "framer-motion";
import { TrackChanges, Timeline, Rule } from "@mui/icons-material";

const campaignFeatures = [
  {
    title: "Connect Your Evangelism into Clear Pathways",
    desc: "See how events, conversations, courses and follow-up fit together instead of managing each activity as a separate ministry.",
    icon: <Timeline sx={{ fontSize: 40, color: "#4ade80" }} />,
  },
  {
    title: "Make the Next Step Clear",
    desc: "Give your team a shared understanding of what has happened, where relationships are going and what needs attention next.",
    icon: <Rule sx={{ fontSize: 40, color: "#4ade80" }} />,
  },
  {
    title: "Learn from Different Approaches",
    desc: "Compare outreach activity and engagement over time so strategic decisions are informed by the fuller picture, not just individual anecdotes.",
    icon: <TrackChanges sx={{ fontSize: 40, color: "#4ade80" }} />,
  },
];

const CampaignsSection = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        py: { xs: 10, md: 14 },
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <Typography
            variant="h3"
            textAlign="center"
            sx={{ color: "#ffffff", fontWeight: 800, mb: 2 }}
          >
            Turn Activity into an Evangelism Strategy
          </Typography>

          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              color: "rgba(255,255,255,0.7)",
              maxWidth: 760,
              mx: "auto",
              mb: 6,
            }}
          >
            Plan how your different outreach activities fit together, coordinate
            the teams delivering them and understand what happens afterwards.
          </Typography>
        </motion.div>

        <Grid2 container spacing={2}>
          {campaignFeatures.map((feature, index) => (
            <Grid2 size={{ xs: 12, md: 4 }} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card
                  sx={{
                    background: "#1e293b",
                    textAlign: "center",
                    p: 3,
                    borderRadius: 4,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                    height: "100%",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 10px 28px rgba(0,0,0,0.35)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box>{feature.icon}</Box>
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ color: "#ffffff", fontWeight: 700 }}
                      gutterBottom
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(255,255,255,0.7)" }}
                    >
                      {feature.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid2>
          ))}
        </Grid2>

        <Box
          sx={{
            position: "relative",
            mt: { xs: 2, md: 2 },
            height: { xs: 520, sm: 600, md: 460 },
            mx: "auto",
          }}
        >
          <Box
            component={motion.img}
            src="/Features/Features-Campaigns.JPG"
            alt="Campaign planning"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            sx={{
              position: "absolute",
              borderRadius: 3,
              boxShadow: "0 40px 120px rgba(0,0,0,0.6)",
              left: { xs: "10%", md: "13%" },
              top: { xs: "0%", md: "0%" },
              width: { xs: "80%", md: "74%" },
              zIndex: 3,
              border: "1px solid rgba(255,255,255,0.14)",
              backgroundColor: "rgba(255,255,255,0.02)",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default CampaignsSection;